import React from 'react'
import ReactDOM from 'react-dom/client'

import configureStore from './store'
import Root from './Root'

export const store = configureStore()
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<Root store={store} />)
